import { apiSlice } from '../../store/api/apiSlice';
export const tlmApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ================= LOGIN =================
    login: builder.mutation<
      any,
      {
        username: string;
        password: string;
      }
    >({
      query: ({ username, password }) => {
        return {
          url: 'testnewlogin',
          method: 'POST',
          // headers: {
          //   'Content-Type': 'application/json',
          //   Accept: 'application/json',
          //   Authorization: 'EMIS@2019_api',
          // },
          body: {
            records: {
              emis_username: username,
              emis_password: password,
            },
          },
          service: 'emis_login',
        };
      },
    }),
  }),
});

export const { useLoginMutation } = tlmApi;
